import { Alert, AlertTitle, Box, Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC, useMemo } from 'react';
import CreateForm from '../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../context/ApplicationContext';
import { UEBERARBEITUNGS_HINWEIS_TITLE } from '../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../lib/types/types';
import { getPruefAssistenzInfoType } from '../application-helper-function/AppHelperfunctions';
import { checkIfHasComment } from '../application-helper-function/PruefAssistenzHelperFunktion';

const PruefAssistenz: FC<{
	statusPath: string;
	hinweisPath: string;
	ueberarbeitetAmPath: string;
	erledigtPath: string;
	formStruc: FormStrucItem[];
	individualReadOnly?: boolean;
	label?: string;
	sx?: object;
}> = ({ statusPath, hinweisPath, erledigtPath, formStruc, individualReadOnly, label, sx }) => {
	const { application, setApplicationProperty, readOnly: globaleReadOnly } = useApplication();

	const readOnly: boolean = useMemo(() => {
		if (individualReadOnly != null || individualReadOnly !== undefined) {
			return individualReadOnly;
		}
		return globaleReadOnly;
	}, [globaleReadOnly, individualReadOnly]);

	const handleUpdatePruefAssistenz = (key: string, value: any) => {
		setApplicationProperty(key, value);
	};

	if (checkIfHasComment(readOnly, application, statusPath)) {
		return (
			<Box sx={{ ...sx, mb: '1rem' }}>
				{label && <Typography sx={{ fontWeight: 'bold', mb: 2 }}>{label}</Typography>}

				<Alert severity={getPruefAssistenzInfoType(application, erledigtPath)}>
					{UEBERARBEITUNGS_HINWEIS_TITLE && <AlertTitle>{UEBERARBEITUNGS_HINWEIS_TITLE}</AlertTitle>}
					{get(application, hinweisPath, 'Bitte überarbeiten Sie diese Inhalte.')}

					<Box sx={{ mt: 2 }}>
						<CreateForm
							formStruc={formStruc}
							formValues={application}
							updateFormValuesFunc={(key, value) => handleUpdatePruefAssistenz(key, value)}
							readOnly={readOnly}
						/>
					</Box>
				</Alert>
			</Box>
		);
	}

	return <></>;
};

export default PruefAssistenz;
